import { CIcon } from '~/icons/types'
export const ciNotifications: CIcon = {
  name: 'notifications',
  type: 'solid',
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'M20.9 15.3c-1.3-1.5-2.1-3.4-2.1-5.5V9c0-3.7-3-6.8-6.8-6.8-3.7 0-6.7 3-6.8 6.7v.8c0 2.1-.8 4.1-2.1 5.5-.1.3-.2.5-.1.8.1.2.2.4.5.5 1.5.6 3.2 1 4.8 1.2v.3c0 2.1 1.7 3.8 3.8 3.8 2.1 0 3.8-1.7 3.8-3.8v-.3c1.7-.3 3.3-.7 4.8-1.2.2-.1.4-.3.5-.5-.1-.3-.2-.5-.3-.7ZM12 20.2c-1.2 0-2.2-1-2.2-2.2v-.1c.7.1 1.4.1 2.2.1.8 0 1.5 0 2.2-.1v.1c0 1.2-1 2.2-2.2 2.2Z',
      fillRule: 'evenodd',
      clipRule: 'evenodd'
    }
  ]
}
